import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

const enc = (invoiceNumber) => encodeURIComponent(invoiceNumber);

export const assignSystemWorkflowInvoice = async (invoiceNumber, body) => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceManagement/workflow/invoice/${enc(invoiceNumber)}/assign`,
      body
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const startSystemWorkflowInvoiceById = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceManagement/workflow/invoice/by-id/${invoiceId}/start`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const stopSystemWorkflowInvoice = async (invoiceNumber, comment = '') => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceManagement/workflow/invoice/${enc(invoiceNumber)}/stop`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const rejectSystemWorkflowInvoice = async (
  invoiceNumber,
  reasonOfRejection,
  comment = ''
) => {
  try {
    const response = await apiClient.post(
      `/systemInvoiceManagement/workflow/invoice/${enc(invoiceNumber)}/reject`,
      { comment, reason_of_rejection: reasonOfRejection }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
